import type { Icon } from '@phosphor-icons/react';
import {
  DatabaseIcon,
  ArrowsClockwiseIcon,
  ArrowsLeftRightIcon,
  DownloadSimpleIcon,
  BracketsCurlyIcon,
  PlugIcon,
  GitBranchIcon,
  WrenchIcon,
  LightningIcon,
  RobotIcon,
  EnvelopeSimpleIcon,
  BugIcon,
  LaptopIcon,
} from '@phosphor-icons/react';

/**
 * Maps workflow step categories to their Phosphor icon components.
 * Shared between the node library and the canvas node renderer.
 */
export const categoryIconMap: Record<string, Icon> = {
  'DataSource Writer': DownloadSimpleIcon,
  'Data Transform': ArrowsClockwiseIcon,
  'DataSource Adapter': ArrowsClockwiseIcon,
  'Data Access': DatabaseIcon,
  Transformation: ArrowsLeftRightIcon,
  Integration: PlugIcon,
  'Control Flow': GitBranchIcon,
  Actions: BracketsCurlyIcon,
  Utility: WrenchIcon,
  Trigger: LightningIcon,
  'AI & Agents': RobotIcon,
  Debug: BugIcon,
  Communications: EnvelopeSimpleIcon,
  'Computer Use': LaptopIcon,
};

const DefaultIcon = WrenchIcon;

export function getCategoryIcon(category: string | undefined): Icon {
  return categoryIconMap[category ?? ''] ?? DefaultIcon;
}
